/**
 * Transformation - Alpine.js components for the "before / after" content element.
 *
 * transformationSlider: drag handle that wipes between two stacked images.
 *   The dragging itself is done by a visually hidden <input type="range"> that
 *   covers the whole stage, so pointer, touch and keyboard all work natively
 *   (arrow keys, Home/End, Page up/down) and the element is announced as a slider.
 *
 * transformationToggle: switches a single stage between the before and the after state.
 *
 * Both components read their configuration from data attributes on the element,
 * so editor supplied labels can never break the inline expression.
 */
document.addEventListener('alpine:init', () => {
    Alpine.data('transformationSlider', () => ({
        position: 50,
        labelBefore: 'Before',
        labelAfter: 'After',

        init() {
            const dataset = this.$el.dataset || {};

            const parsed = Number.parseInt(dataset.start, 10);
            this.position = Number.isNaN(parsed) ? 50 : Math.min(100, Math.max(0, parsed));

            if (dataset.labelBefore) {
                this.labelBefore = dataset.labelBefore;
            }
            if (dataset.labelAfter) {
                this.labelAfter = dataset.labelAfter;
            }

            console.log('[Transformation] slider init:', {
                element: this.$el,
                start: dataset.start,
                position: this.position,
                labels: { before: this.labelBefore, after: this.labelAfter }
            });
        },

        /** Clip the "after" layer so only the part right of the handle stays visible. */
        get afterStyle() {
            return 'clip-path: inset(0 0 0 ' + this.position + '%)';
        },

        get handleStyle() {
            return 'left: ' + this.position + '%';
        },

        /** Announced by screen readers, e.g. "60% After". */
        get valueText() {
            return Math.round(this.position) + '% ' + this.labelAfter;
        },

        onInput(event) {
            const value = Number.parseInt(event.target.value, 10);
            if (Number.isNaN(value)) {
                console.warn('[Transformation] slider received a non-numeric value:', event.target.value);
                return;
            }
            this.position = value;
        },

        /** Jump to a fixed position - used by the label buttons. */
        goTo(value) {
            const parsed = Number.parseInt(value, 10);
            if (Number.isNaN(parsed)) {
                console.warn('[Transformation] goTo called with a non-numeric value:', value);
                return;
            }
            this.position = Math.min(100, Math.max(0, parsed));
            console.log('[Transformation] slider jumped to:', this.position);
        }
    }));

    Alpine.data('transformationToggle', () => ({
        state: 'before',

        init() {
            const dataset = this.$el.dataset || {};
            this.state = dataset.initialState === 'after' ? 'after' : 'before';
            console.log('[Transformation] toggle init:', { element: this.$el, state: this.state });
        },

        get isBefore() {
            return this.state === 'before';
        },

        get isAfter() {
            return this.state === 'after';
        },

        show(state) {
            if (state !== 'before' && state !== 'after') {
                console.warn('[Transformation] show() called with an unknown state:', state);
                return;
            }
            this.state = state;
            console.log('[Transformation] toggle switched to:', this.state);
        },

        toggle() {
            this.show(this.isBefore ? 'after' : 'before');
        }
    }));
});
